export enum DrivingRequestEvidenceRelationEnum {
  COMPATIBLE = 'compatible',
  CONTRADICTORY = 'contradictory',
  NEUTRAL = 'neutral',
  INDETERMINATE = 'indeterminate',
}

export interface DrivingRequestEvidenceRelationVisual {
  label: string;
  icon: string;
  cssClass: string;
}

export function getDrivingRequestEvidenceRelationLabel(relation: DrivingRequestEvidenceRelationEnum): string {
  switch (relation) {
    case DrivingRequestEvidenceRelationEnum.COMPATIBLE:
      return 'Compatible';
    case DrivingRequestEvidenceRelationEnum.CONTRADICTORY:
      return 'Contradictoria';
    case DrivingRequestEvidenceRelationEnum.NEUTRAL:
      return 'Neutral';
    case DrivingRequestEvidenceRelationEnum.INDETERMINATE:
      return 'Sin datos suficientes';
  }
}

export function getDrivingRequestEvidenceRelationVisual(
  relation: DrivingRequestEvidenceRelationEnum
): DrivingRequestEvidenceRelationVisual {
  switch (relation) {
    case DrivingRequestEvidenceRelationEnum.COMPATIBLE:
      return { label: getDrivingRequestEvidenceRelationLabel(relation), icon: 'check_circle', cssClass: 'relation-compatible' };
    case DrivingRequestEvidenceRelationEnum.CONTRADICTORY:
      return { label: getDrivingRequestEvidenceRelationLabel(relation), icon: 'error', cssClass: 'relation-contradictory' };
    case DrivingRequestEvidenceRelationEnum.NEUTRAL:
      return { label: getDrivingRequestEvidenceRelationLabel(relation), icon: 'remove_circle_outline', cssClass: 'relation-neutral' };
    case DrivingRequestEvidenceRelationEnum.INDETERMINATE:
      return { label: getDrivingRequestEvidenceRelationLabel(relation), icon: 'help_outline', cssClass: 'relation-indeterminate' };
  }
}
